import React from "react";

/**
 * Section title with the signature orange underline bar.
 * align: "left" | "center"
 */
const SectionHeading = ({
  title,
  subtitle,
  align = "left",
  className = "",
  titleClassName = "text-on-surface",
}) => {
  const centered = align === "center";
  return (
    <div
      className={`${centered ? "text-center" : "text-left"} ${className}`}
    >
      <h2
        className={`font-headline-xl text-3xl md:text-headline-xl uppercase ${titleClassName}`}
      >
        {title}
      </h2>
      <div
        className={`mt-4 h-1 w-24 bg-primary-container ${centered ? "mx-auto" : ""}`}
      />
      {subtitle && (
        <p className="mt-6 max-w-2xl font-body-lg text-body-lg text-on-surface-variant">
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default SectionHeading;
